<script>
  import { link } from "svelte-routing";
</script>

<div class="pre-login-hero-section">
  <div class="pre-login-hero-section-inner-content">
    <h1>Checklists arranged in columns</h1>
    <div class="pre-login-hero-section-inner-content-right-section">
      <p class="right-section-description">
        Keep your thoughts, notes, tasks, projects, watchlists and plans
        organized. For teams & individuals.
      </p>
      <a href="signup" use:link>
        <button>Get Started</button>
      </a>
    </div>
  </div>
</div>

<style lang="scss">
  .pre-login-hero-section {
    padding: 60px 0px;
    padding-bottom: 0px;
    .pre-login-hero-section-inner-content {
      max-width: 1031px;
      margin: 0px auto;
      padding: 0px 40px;
      transition: padding 0.1s ease 0s;
      display: flex;
      -webkit-box-pack: justify;
      justify-content: space-between;
      flex-wrap: nowrap;
      padding-bottom: 226px;
      h1 {
        position: relative;
        z-index: 10;
        width: 770px;
        margin-right: 10px;
        font-family: Graphik, -apple-system, "Segoe UI", "Helvetica Neue",
          Roboto, Oxygen-Sans, Ubuntu, Cantarell, sans-serif;
        font-weight: 700;
        font-size: 12rem;
        line-height: 84%;
        letter-spacing: -0.04em;
      }
      .pre-login-hero-section-inner-content-right-section {
        width: 307px;
        margin-top: 24px;
        .right-section-description {
          font-size: 2rem;
          line-height: 140%;
          margin-bottom: 42px;
          color: rgb(135, 135, 135);
        }
      }
      a {
        button {
          max-width: 238px;
          padding: 12px 0px;
          font-size: 2rem;
          line-height: 2.4rem;
          font-weight: bold;
          width: 240px;
          margin: 0px auto;
          display: block;
          color: rgb(255, 255, 255);
          background: rgb(35, 135, 251);
          border-radius: 6px;
          box-shadow: rgb(0 0 0 / 25%) 0px 2px 6px, rgb(0 0 0 / 25%) 0px 1px 2px;
          transition: box-shadow 0.1s ease 0s;
          &:hover {
            box-shadow: rgb(0 0 0 / 25%) 0px 2px 6px,
              rgb(0 0 0 / 25%) 0px 1px 2px, rgb(35 135 251) 0px 0px 0px 2px;
          }
        }
      }
    }
  }
</style>
